<div class="center-horizontal">
    <div class="example-form">
        <button mat-raised-button color="primary" (click)="castVote()">CAST A VOTE</button>
        <button mat-raised-button color="primary" >CONSTITUENCY DETAILS</button>
        <button mat-raised-button color="primary" (click)="registerVoter()">REGISTER A VOTER</button>
    </div>
</div>